import { LaboratoryTestInfoProvider } from 'hook/UseLaboratoryTestInfo';
import React from 'react';
import { Route } from 'react-router-dom';

const ProductTestRoute = (props) => {
  return (
    <LaboratoryTestInfoProvider>
      <Route {...props} />
    </LaboratoryTestInfoProvider>
  );
};

export default ProductTestRoute;